import React from 'react'
import { useState, useEffect, useRef } from 'react'
import { useParams, useNavigate, Link } from 'react-router-dom'
import { motion } from 'framer-motion';

import { Helmet } from 'react-helmet-async';
import { useContext } from 'react'
import { SearchContext } from './Contexts/Context'

import { FacebookShareButton, TwitterShareButton } from 'react-share'
import { FaEnvelope, FaPhoneAlt, FaFacebookF, FaTwitter, FaAngleLeft, FaInstagram, FaYoutube } from 'react-icons/fa'
import { getMeriisSamsakhurebiBySlug } from '../service/service';
import { MeriaInner } from './MeriaInner';

function MeriisSamsakhurebi1() {
  const ref = useRef(null)
  const [width, setWidth] = useState(10)
  const { language } = useContext(SearchContext)
  const navigate = useNavigate();
  const { id } = useParams();

  const [moadgile, setMoadgile]= useState([])
  const [loading, setLoading] = useState(true)

  console.log("moadgile", moadgile);

    useEffect(() => {
      const getMerisMoadgile = async () => {
        try {
          const data = await getMeriisSamsakhurebiBySlug(id);
          setMoadgile(data);
          setLoading(false);
        } catch (error) {
          console.error('Error fetching meris moadgileebi:', error);
          setLoading(true);
        }
      };
      getMerisMoadgile();
    }, []);


  return (
    <motion.div
      intial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}>

      {loading ? (
        <p>Loading...</p>
      ) : (
          <div className=" margin-280px">
            <MeriaInner data={moadgile} />
          </div>
      )}

    </motion.div>
  )
}

export default MeriisSamsakhurebi1